import React from "react";
import {connect} from "react-redux";
import LoginForm from "../clientdata/LoginForm";

import ContractPartnerSimpleForm from './ContractPartnerSimpleForm'

import {isClientDataStepValid} from '../../selectors/StepValidation'

import * as StepLabels from "../../constants/StepLabels";
import {putFormData} from "../../actions/FormData";
import {forceValidationOnSteps} from "../../actions/StepControl";
import {existingCustomerSelected, newCustomerSelected} from "../../actions/UserAuthentication";
import {_orderTitle} from "../../selectors/GetParam";
import {getBaseArticle} from "../../selectors/SimpleSelectors";

function ClientDataStepSimple(props) {


    if (props.isNewCustomerSelected) {

        return (
            <div className="step-display__page clientdata-step clientdata-step--simple">

                <h2>{_orderTitle ? _orderTitle :  'Neukunde'}</h2>

                <div className="clientdata-step__clienttype">
                    <button type="button" className="selected">
                        Ich bin Neukunde
                    </button>
                    <button
                        type="button" onClick={(e) => {
                        props.existingCustomerSelected()
                    }}>
                        Ich bin bereits Kunde
                    </button>
                </div>

                <ContractPartnerSimpleForm
                    forceValidation={props.forcedValidationSteps.includes(StepLabels.STANDALONE)}
                    optionals={props.baseArticle && props.baseArticle.articleNumber === 30000 ? ["note", "title", "vat"] : ["note", "title", "vat", "phone"]}
                />

            </div>
        );
    } else if (props.isExistingCustomerSelected) {
        return (
            <div className="step-display__page clientdata-step clientdata-step--simple">

                <h2>{_orderTitle ? _orderTitle :  'Bestandskunde'}</h2>

                <div className="clientdata-step__clienttype">
                    <button type="button" onClick={(e) => {
                        props.newCustomerSelected()
                    }}>
                        Ich bin Neukunde
                    </button>
                    <button type="button" className="selected">
                        Ich bin bereits Kunde
                    </button>
                </div>

                <LoginForm
                    forceValidation={props.forcedValidationSteps.includes(StepLabels.STANDALONE)}
                />

            </div>
        );
    }
}

ClientDataStepSimple.propTypes = {};

const mapStateToProps = (state, ownProps) => {
    return {
        baseArticle: getBaseArticle(state),
        clientDataStepValid: isClientDataStepValid(state),
        forcedValidationSteps: state.ui.forcedValidationSteps,
        isExistingCustomerSelected: state.clientDataStep.existingCustomerSelected,
        isNewCustomerSelected: state.clientDataStep.newCustomerSelected,
        existingUserAuthenticated: state.clientDataStep.existingUserAuthenticated,
    }
}


const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        putFormData: () => {
            dispatch(putFormData())
        },
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        },
        existingCustomerSelected: () => {
            dispatch(existingCustomerSelected())
        },
        newCustomerSelected: () => {
            dispatch(newCustomerSelected())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null)(ClientDataStepSimple)



/** WEBPACK FOOTER **
 ** ./src/containers/clientdatasimple/ClientDataStepSimple.js
 **/